import { Injectable } from "@angular/core";
import { ResultListVO } from "@app/shared/vo/resultList.vo";
import { MapperInterface } from "./mapper-inteface";
import { ResultListDTO } from "../dto/result-listDTO";
import { MapperPaginazione } from "./mapper-paginazione";
import { MapperFascicolo } from "./mapper-fascicolo";
import { AttivitaUnitaDocumentariaDTO } from "../dto/attivita-unita-documentariaDTO";
import { AttivitaUnitaDocumentariaVO } from "../vo/attivita-unita-documentariaVO";
import { MapperAttivitaUnitaDocumentaria } from "./mapper-attivita-unita-doocumentaria";


@Injectable({
  providedIn: "root",
})
export class MapperResultListAttivitaUnitaDocumentaria
  implements
    MapperInterface<
      ResultListDTO<AttivitaUnitaDocumentariaDTO>,
      ResultListVO<AttivitaUnitaDocumentariaVO>
    > {
  constructor(
    private mapperFascicolo: MapperFascicolo,
    private mapperAttivitaUnitaDocumentaria: MapperAttivitaUnitaDocumentaria,
   private paginazioneMapper: MapperPaginazione
  ) {}

  convertVoToDto(
    vo: ResultListVO<AttivitaUnitaDocumentariaVO>
  ): ResultListDTO<AttivitaUnitaDocumentariaDTO> {
    const dto = new ResultListDTO<AttivitaUnitaDocumentariaDTO>();
    if (vo != null) {
      dto.descrizione = vo.descrizione;
      dto.paginazione = this.paginazioneMapper.convertVoToDto(vo.paginazione);
      dto.stato = vo.stato;
      dto.resultList = this.mapperAttivitaUnitaDocumentaria.convertListVoToDto(
        vo.resultList
      );
    }
    return dto;
  }

  convertDtoToVo(
    dto: ResultListDTO<AttivitaUnitaDocumentariaDTO>
  ): ResultListVO<AttivitaUnitaDocumentariaVO> {
    const vo = new ResultListVO<AttivitaUnitaDocumentariaVO>();
    if (dto != null) {
      vo.descrizione = dto.descrizione;
      vo.paginazione = this.paginazioneMapper.convertDtoToVo(dto.paginazione);
      vo.stato = dto.stato;
      vo.resultList = this.mapperAttivitaUnitaDocumentaria.convertListDtoToVo(
        dto.resultList
      );
    }
    return vo;
  }

  convertListVoToDto(
    voList: ResultListVO<AttivitaUnitaDocumentariaVO>[]
  ): ResultListDTO<AttivitaUnitaDocumentariaDTO>[] {
    return voList.map((vo) => this.convertVoToDto(vo));
  }

  convertListDtoToVo(
    dtoList: ResultListDTO<AttivitaUnitaDocumentariaDTO>[]
  ): ResultListVO<AttivitaUnitaDocumentariaVO>[] {
    return dtoList.map((dto) => this.convertDtoToVo(dto));
  }
}
